import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "CONTACT"),
  /*#__PURE__*/_createElementVNode("h1", null, "Visit Us Today")
], -1)
const _hoisted_3 = { class: "footer-row" }
const _hoisted_4 = { class: "footer-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Visit Shop", -1)
const _hoisted_6 = { class: "footer-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Get In Touch", -1)
const _hoisted_8 = { class: "social-links" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Copyright TT Exclusive Co., Ltd", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_box_icon = _resolveComponent("box-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", null, [
          _createVNode(_component_box_icon, {
            name: "cart-download",
            color: "#009688",
            class: "me-3"
          }),
          _createTextVNode("Shopee : tt_exclusive shop")
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_box_icon, {
            name: "cart-download",
            color: "#009688",
            class: "me-3"
          }),
          _createTextVNode("LAZADA : tt_exclusive shop")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, [
          _createTextVNode("#146 Srinakarin Rd., Bangphli, Samutprakan"),
          _createVNode(_component_box_icon, {
            name: "map-alt",
            color: "#009688",
            class: "ms-3"
          })
        ]),
        _createElementVNode("p", null, [
          _createTextVNode("Tel : +66 99 3608986"),
          _createVNode(_component_box_icon, {
            name: "phone-call",
            color: "#009688",
            class: "ms-3"
          })
        ]),
        _createElementVNode("p", null, [
          _createTextVNode("Email : geotextile26@gmail.com"),
          _createVNode(_component_box_icon, {
            name: "paper-plane",
            color: "#009688",
            class: "ms-3"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_box_icon, {
        name: "facebook-square",
        type: "logo",
        animation: "tada-hover",
        color: "#009688",
        size: "50px"
      }),
      _createVNode(_component_box_icon, {
        name: "youtube",
        type: "logo",
        animation: "tada-hover",
        color: "#009688",
        size: "50px",
        class: "mx-3"
      }),
      _createVNode(_component_box_icon, {
        name: "instagram",
        type: "logo",
        animation: "tada-hover",
        color: "#009688",
        size: "50px"
      }),
      _hoisted_9
    ])
  ]))
}